// Stuck symptoms documented in investigation/commands.md:259 — session is
// active but pending_command_error is set to one of these hard-error values
// and the device has stopped responding to commands.
//   3 = EXECUTION_FAILED — device received the command but couldn't execute it.
//   4 = DELIVERY_FAILED  — command couldn't be delivered (device offline).
export const PENDING_COMMAND_ERROR_STUCK_VALUES = [3, 4];

const SES_STATUS_ACTIVE = 1;

// Deliberately ignores `online`: a device that never reconnects
// (decommissioned, dead Wi-Fi) would otherwise leave its session active in
// the portal forever with no way to clear it. Reset ends the session
// backend-side regardless of connectivity; an offline device that does come
// back reconciles against the ended session on reconnect.
export const isSessionStuck = (device) =>
  device.session_id != null &&
  device.session_status === SES_STATUS_ACTIVE &&
  (PENDING_COMMAND_ERROR_STUCK_VALUES.includes(device.pending_command_error) ||
    device.online === false ||
    device.process_type === 0);
